<div class="dialog-header">
    <button class="close-icon" mat-dialog-close mat-icon-button tabindex="-1">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div class="dialog-content">
    <div class="title">{{ 'mfaInputDialog.title' | translate }}</div>
    <div class="content">
        <p>
            {{ 'mfaInputDialog.mfaSent' | translate }}&nbsp;<span class="email">{{ emailAddress }}</span>.<br>
            {{ 'mfaInputDialog.mfaExpiration' | translate }}&nbsp;{{ mfaExpiration | date:"MM/dd/yyyy h:mm a" }}.
        </p>
        <form (ngSubmit)="submitForm($event)" [formGroup]="formGroup">
            <mat-form-field class="compact">
                <input formControlName="mfa" matInput placeholder="MFA Code" type="text">
                <mat-error>
                    @if (formGroup.controls.mfa.hasError('validate')) {
                        <span class="mfa-invalid">
                            <span class="material-icons">warning</span>
                            <span>{{ 'mfaInputDialog.incorrectMfaCode' | translate }}</span>
                        </span>
                    }
                </mat-error>
            </mat-form-field>
            <button *spinOn="isValidatingCode"
                    color="primary"
                    mat-flat-button
                    type="submit">{{ 'mfaInputDialog.submit' | translate }}
            </button>
        </form>
        <p class="resend-message">
            <span>{{ 'mfaInputDialog.notReceivedCode' | translate }}</span>
            <a (click)="resendMFACode($event)"
               *spinOn="isResendingMFACode"
               href="#"
               mat-button>{{ 'mfaInputDialog.resendMFA' | translate }}</a>
        </p>
    </div>
</div>
